var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"userBox"},[(_vm.isAuthenticated)?_c('ul',[_c('li',[_c('i',{staticClass:"iconUser mdi mdi-account"}),_vm._v(_vm._s(_vm.loggedInUser))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }